<template>
    <div class="page wallet">
        <mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>
        <pageTitle title='现金券明细' :showRight='true' @rightHandler='goRule' rightTitle='提现 ' ></pageTitle>
        <div class="mycoin">
            我的现金券
            <h2>￥{{wallet.MyCash}}</h2>
        </div>
        <div class="demo-refresh-container">
            <div class="list">
                <div class="item" v-for="item in coinRecords">
                    <div class="date">
                        {{item.operateDate | detailDate}}
                    </div>
                    <div>
                        <span class='strong'>{{item.moneyOperateComent}}</span><br/>
                        <span class='detail'>备注:{{item.data | remark }}</span>
                    </div>
                    <div>
                        <span class='num'>{{item.operateMoney | discount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <loadListTail mainTitle='暂无现金账户记录' mainIcon='noDetail' :noMore='loadState.stop' :isLoading='loadState.loading' :overZero='coinRecords.length > 0'  />
        <div class='loading' v-if='loadState.loading'>
            <img src="../../../static/LoadingBest.gif" />
        </div>
    </div>
</template>

<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import Scroll from '../../utils/loading'
import loadListTail from '../../components/loadListTail'

export default {
  data () {
    return {
        coinRecords:[],
        refreshing: false,
        trigger: null,
        loadState:'',
        scroll:null
    }
  },
  components:{
    loadListTail
  },
  activated(){
    this.scroll.addHandler()
  },
  deactivated(){
    this.scroll.removeHandler()
  },
  mounted(){
    this.trigger = this.$el
    this.scroll = Scroll.Create(this,this.getData,10,1)
  },
  methods: {

    goRule() {
      this.$router.push({ path: "/wallet/cashExtractCash" });
    },


    initData(){
        //清空显示数据
        this.coinRecords = []
        //初始化本页控制数据、分页参数
        this.scroll.refresh()
    },
    getData () {
      var that = this
      var params = new this.URLSearchParam();
      params.append('pageIndex', this.pageParam.index);
      params.append('pageSize', 10);
      params.append('type', 1);
      //search里异步加载完毕后，将isloading设置为false，根据返回的数据判断是否加载完毕，设置stop的值
      return new Promise(function(resolve, reject) {
        that.$http.post(api.getCashLog(),params.toParam()).then((res) => {
            if(res.Result){
                var temp = res.Data;
                resolve(temp.length);
                that.coinRecords =that.coinRecords.concat(temp);
            }
            else{
                resolve(null);
                that.$router.push({ path: '/user/Login' })
            }
        }).catch(function (error) {
            reject();
        });
      })
    },
    refresh () {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    }
  },
  computed:{
      ...mapGetters({
        wallet:'g_walletInfo'
      })
  }
}
</script>


// WEBPACK FOOTER //
// cashDetail.vue?122658e6